<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline" :form="form">
        <a-row :gutter="48">
          <a-col :md="8" :sm="24">
            <a-form-item label="查询">
              <a-input placeholder="用户名/昵称/邮箱" v-decorator="[ 'number']"/>
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <a-form-item label="添加时间">
              <select-time ref="time"/>
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="handleSearch">查询</a-button>
              <a-button style="margin-left: 20px" @click="handleAdd">添加</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <s-table
      size="default"
      :columns="columns"
      :data="loadData"
      @add_user_ok="reloadData()"

      ref="datatable"
      :showPagination=true
    >
      <span slot="action" slot-scope="text, record">
        <a-tag size="small" color="blue" @click="handleEdit(record)" v-if="isProjectCreater()">授权</a-tag>
        <a-tag size="small" color="red" @click="handleDelete(record)" v-if="isProjectCreater()">删除</a-tag>
      </span>
      <span slot="permission" slot-scope="permission">
        <a-tag v-for="tag in permission" :key="tag" :color="/user/.test(tag)? 'green' : 'purple'" size="small" >{{ `${getPermissionText(tag)}` }}</a-tag>
      </span>
      <span slot="avatar" slot-scope="user_avatar">
        <a-avatar :src="user_avatar"/>
      </span>
    </s-table>

    <add-user-modal ref="addUserModal" @add_user_ok="reloadData" />
    <add-permission-modal ref="addPermissionModal" @authorize_ok="reloadData" />

  </a-card>
</template>

<script>
import STable from '@/components/table/'
import AddPermissionModal from './modules/AddPermissionModal'
import AddUserModal from './modules/AddUserModal'
import SelectTime from '@/components/selector/SelectTime'

import { mapActions } from 'vuex'
import { deleteProjectUser, getProjectUserList } from '@/api/project'
import { getPermissionText } from '@/utils/const'
// import { getRoleList, getServiceList, getUserList } from '@/api/manage'
import { axios } from '@/utils/request'
import { DatabaseOutline } from '@ant-design/icons/lib/dist'
import { mapGetters } from 'vuex'

export default {
  name: 'MemberList',
  components: {
    STable,
    AddUserModal,
    AddPermissionModal,
    SelectTime
  },
  data () {
    return {

      visible: false,
      conditions: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      form: this.$form.createForm(this),
      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {},
      // 表头
      columns: [
        {
          title: '编号',
          dataIndex: 'id',
          key: 'id'
        },
        {
          title: '头像',
          dataIndex: 'user_avatar',
          key: 'user_avatar',
          scopedSlots: { customRender: 'avatar' }
        },
        {
          title: '用户名',
          dataIndex: 'user_name',
          key: 'user_name'
        },
        {
          title: '权限',
          dataIndex: 'permission',
          key: 'permission',
          scopedSlots: { customRender: 'permission' }
        },
        {
          title: '昵称',
          dataIndex: 'user_nickname',
          key: 'user_nickname'
        },
        {
          title: '邮箱',
          dataIndex: 'user_mail',
          key: 'user_mail'
        },
        {
          title: '手机号',
          dataIndex: 'user_mobile',
          key: 'user_mobile'
        },
        {
          title: '添加时间',
          dataIndex: 'create_at',
          key: 'create_at'
        },

        {
          title: '操作',
          width: '150px',
          dataIndex: 'action',
          key: 'action',
          scopedSlots: { customRender: 'action' }
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: (page) => {
        const _this = this
        return new Promise(resolve => {
          return getProjectUserList(Object.assign({
            item_id: _this.$store.getters.projectId,
            page_num: page.pageNo,
            page_size: page.pageSize
          }, _this.conditions)).then(res => {
            if (res.data.length == 0) {
              _this.$refs.datatable.localLoading = false
              const params = {
                data: [],
                pageNo: 1,
                pageSize: 10,
                totalCount: 0
              }
              resolve(params)
              return
            }
            const datas = []
            var i = 1
            for (let item = res.data.shift(); item != null; item = res.data.shift()) {
              datas.push({
                id: i,
                user_avatar: item.user_avatar,
                user_name: item.user_name,
                user_nickname: item.user_nickname,
                user_mail: item.user_mail,
                user_mobile: item.user_mobile,
                create_at: item.create_at,
                permission: item.member_permission.split(','),
                originData: item
              })
              i += 1
            }
            const params = {
              data: datas,
              pageNo: page.pageNo,
              pageSize: page.pageSize,
              totalCount: res.total
            }
            resolve(params)
          }).catch(() => {
            this.$refs.datatable.localLoading = false
          })
        })
      },

      selectedRowKeys: [],
      selectedRows: []
    }
  },

  methods: {
    ...mapGetters(['isProjectCreater']),
    getPermissionText: getPermissionText,
    handleEdit (record) {
      debugger
      this.$refs.addPermissionModal.edit(record.originData)
      this.visible = true
    },
    handleSearch () {
      const conditions = this.conditions = {}
      this.form.validateFields((err, values) => {
        if (values.number)conditions.q = values.number
      })
      if (this.$refs.time.value.isNull == false) {
        conditions.start_at = this.$refs.time.value.from
        conditions.end_at = this.$refs.time.value.to
      }
      this.reloadData()
    },
    handleOk () {

    },
    onChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    reloadData () {
      debugger
      this.$refs.datatable.refresh()
    },
    handleAdd () {
      this.$refs.addUserModal.add()
    },
    handleDelete (record) {
      const _this = this
      _this.$confirm({
        title: '真的要删除用户\'' + record.user_name + '\'吗？',
        content: '单击确定删除',
        onOk () {
          return new Promise((resolve, reject) => {
            const projectId = _this.$store.getters.projectId
            const user_uid = record.originData.member_uid
            deleteProjectUser(user_uid, projectId).then(res => {
              _this.$message.success('删除成功')
              resolve()
            }).catch(() => {
              _this.$message.error('删除失败')
              reject()
            }).finally(() => {
              _this.reloadData()
            }
            )
          })
        },
        onCancel () {}
      })
    }
  }

}
</script>
